import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getGroupsList, deleteGroup, getCourses, clearGroupItem } from '../../actions/groupsDoVd'
import { getSchoolYears, getTermTypes } from '../../actions/common'
import Loader from '../../components/Loader'
import Empty from '../../components/Empty'
import Title from '../../components/Title'
import Search from './Search'

export default function GroupsDoVd({ type = 0, title = 'Группы' }) {
    const dispatch = useDispatch();
    const { list, loading, courses } = useSelector(state => state.groups_do_vd);
    const { schoolYears, termTypes } = useSelector(state => state.common);

    const [params, setParams] = useState({});
    const [confirmation, setConfirmation] = useState(false);
    const [mode, setMode] = useState('main');
    const [id, setId] = useState(null);

    useEffect(() => {
        dispatch(getSchoolYears());
        dispatch(getCourses(type));
        dispatch(getTermTypes());
    }, [type]);

    useEffect(() => {
        dispatch(getGroupsList(type, params));
    }, [params, type]);

    const acceptConfirmation = () => {
        closeModal();
        dispatch(deleteGroup(confirmation.id, type, params));
        setConfirmation(false);
    };

    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    const openModal = (id) => () => {
        setId(id);
    };

    const closeModal = () => {
        setId(null);
        setMode('main');
        dispatch(clearGroupItem());
    };

    const renderRow = (data) => {
        const { xp_key, name, course_name, student_count, closed } = data;
        return (
            <tr key={xp_key}>
                <td onClick={openModal(xp_key)}>{name}</td>
                <td onClick={openModal(xp_key)}>{course_name}</td>
                <td onClick={openModal(xp_key)}>{student_count || 0}</td>
                <td onClick={openModal(xp_key)}>{closed ? 'Закрыта' : 'Открыта'}</td>
                <td>
                    <i
                        className={styles.trash}
                        onClick={() => setConfirmation({ id: xp_key, name: name })}>
                        <BiTrash />
                    </i>
                </td>
            </tr>
        );
    };

    const handleChange = (name, value) => {
        setParams({
            ...params,
            [name]: value
        });
    };

    return (
        <div
            className={styles.wrapper}
            style={{
                width: '100%',
                margin: '0 auto'
            }}>

            {confirmation && (
                <Confirmation
                    top="30px"
                    left="40px"
                    title={`Вы уверены, что хотите удалить "${confirmation.name}"?`}
                    acceptConfirmation={() => acceptConfirmation(confirmation?.id)}
                    rejectConfirmation={rejectConfirmation}
                />
            )}

            <Modal
                id={id}
                type={type}
                params={params}
                closeModal={closeModal}
                mode={mode}
                setMode={setMode}
                schoolYears={schoolYears}
                termTypes={termTypes}
            />

            <Title title={title} />

            <Search params={params} handleChange={handleChange} courses={courses} />

            {loading && <div className={styles.loader}><Loader /></div>}

            {!loading && !list?.length
                ? <Empty />
                : <Table className={styles.tables}>
                    <thead>
                        <tr>
                            <th>Название</th>
                            <th>Дисциплина</th>
                            <th>Кол-во учащихся</th>
                            <th>Статус</th>
                            <th width={'1.5rem'}>Удалить</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list?.map(renderRow)}
                    </tbody>
                </Table>}

            <div
                style={{
                    display: 'flex',
                    flexDirection: "row"
                }}>
                <Button
                    style={{
                        padding: '.5rem 1.5rem',
                        margin: '12px'
                    }}
                    onClick={openModal('add')}>
                    <IoIosAdd size={30} />
                    Добавить
                </Button>
            </div>
        </div>
    );
}
